<!-- 商品分类管理 -->
<template>
  <div class="diseaseList">
    <el-form :inline="true">
      <!-- <el-button
        class="addBtn"
        type="primary"
        size="small"
        v-waves
        @click="handleAdd"
        style="margin:10px"
      >新增</el-button> -->
      <el-form-item label="分类状态:" style="margin:10px" size="small">
        <el-select v-model="listQuery.status" placeholder="请选择" clearable>
          <div v-for="(item, index) in statusList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="是否首页推荐:" style="margin:10px" size="small">
        <el-select v-model="listQuery.recommend" placeholder="请选择" clearable>
          <div v-for="(item, index) in recommendList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item label="分类名称: " style="margin:10px" size="small">
        <el-input v-model="listQuery.categoryName" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="分类等级:" style="margin:10px" size="small">
        <el-select
          v-model="listQuery.categoryLevel"
          placeholder="请选择"
          clearable
          @change="changeLevel"
        >
          <div v-for="(item, index) in stateList" :key="index">
            <el-option :label="item.name" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item
        label="父分类名称:"
        style="margin:10px"
        size="small"
        v-if="listQuery.categoryLevel == 2"
      >
        <el-select v-model="listQuery.parentID" placeholder="请选择" clearable filterable>
          <div v-for="(item, index) in parentList_one" :key="index">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item
        label="父分类名称:"
        style="margin:10px"
        size="small"
        v-if="listQuery.categoryLevel == 3"
      >
        <el-select v-model="listQuery.parentID" placeholder="请选择" clearable filterable>
          <div v-for="(item, index) in parentList_two" :key="index">
            <el-option :label="item.categoryName" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>

      <el-button
        class="addBtn"
        type="primary"
        @click="search"
        size="small"
        v-waves
        style="margin:10px"
      >搜索</el-button>
      <el-button
        class="addBtn"
        type="primary"
        size="small"
        v-waves
        style="margin-right: 20px"
        :loading="downloadLoading"
        icon="el-icon-document"
        @click="handleDownload"
      >
        导出 Excel（数量/ {{ tableData.length
        }}条）
      </el-button>
    </el-form>

    <div class="tableList">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
        :listQuery="listQuery"
      >
        <!-- 是否设为首页推荐 -->
        <template slot="recommend" slot-scope="{ row }">
          <el-switch
            :value="row.recommend == 1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="recommendChange(row, $event)"
          ></el-switch>
        </template>
        <template slot="img_head" slot-scope="{ row }">
          <el-image
            class="elImage"
            :src="row.img_head"
            :preview-src-list="[row.img_head]"
            v-if="row.img_head"
          ></el-image>
          <div v-else>暂未上传</div>
        </template>

        <template slot="parentID" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.parentID">
            {{
            arrayByIdToNameStr({
            ArrayData: allTableData,
            ID: row.parentID,
            })
            }}
          </el-tag>
          <span v-else>-</span>
        </template>

        <template slot="status" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.status == 0">正常</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-else>下架</el-tag>
        </template>
        <template slot="categoryLevel" slot-scope="{ row }">
          <el-tag type="success" effect="dark" size="mini" v-if="row.categoryLevel == 1">一级分类</el-tag>
          <el-tag effect="dark" size="mini" v-if="row.categoryLevel == 2">二级分类</el-tag>
          <el-tag type="danger" effect="dark" size="mini" v-if="row.categoryLevel == 3">三级分类</el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button class="editBtn" size="mini" type="text" @click="handleEdit(row)" primary>编辑</el-button>
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0)"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>

    <!-- 表单弹窗 -->
    <el-dialog :title="dialogName" :visible.sync="dialogVisible" :close-on-click-modal="false">
      <el-form ref="form" :model="dialogForm" label-width="160px">
        <el-form-item label="分类状态:" required>
          <el-select v-model="dialogForm.status" placeholder="请选择" clearable>
            <div v-for="(item, index) in statusList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="分类等级:" required>
          <el-select
            v-model="dialogForm.categoryLevel"
            placeholder="请选择"
            clearable
            @change="changeLevel"
          >
            <div v-for="(item, index) in stateList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="父分类名称:" v-if="dialogForm.categoryLevel === 2" required>
          <el-select v-model="dialogForm.parentID" placeholder="请选择" clearable>
            <div v-for="(item, index) in parentList_one" :key="index">
              <el-option :label="item.categoryName" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>
        <el-form-item label="父分类名称:" v-if="dialogForm.categoryLevel === 3" required>
          <el-select v-model="dialogForm.parentID" placeholder="请选择" clearable>
            <div v-for="(item, index) in parentList_two" :key="index">
              <el-option :label="item.categoryName" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>

        <el-form-item label="分类名称" required>
          <el-input clearable v-model="dialogForm.categoryName" placeholder="请输入"></el-input>
        </el-form-item>
        <el-form-item label="分类介绍">
          <el-input
            clearable
            v-model="dialogForm.message"
            placeholder="请输入"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input
            clearable
            v-model.number="dialogForm.sort"
            type="number"
            placeholder="请输入数字,越大排名越前"
          ></el-input>
        </el-form-item>
        <el-form-item label="分类主图">
          <el-input clearable v-model="dialogForm.img_head" placeholder="图片地址"></el-input>
          <el-upload
            name="formData"
            class="upload-demo"
            :action="action"
            :on-success="(response) => {
            return handleSuccess(response);
          }
            "
            multiple
            :limit="1"
            :file-list="fileList"
          >
            <el-button
              class="addBtn uploadPic"
              size="mini"
              type="primary"
              style="padding: 9px 5px"
            >上传图片</el-button>
            <div slot="tip">请上传jpg，png格式</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancelBtn" size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button class="addBtn" size="small" type="primary" @click="save">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import { mapState } from "vuex";
import { IP } from "@/services/config.js";
import {
  queryList,
  deleteList,
  updateList,
  addList
} from "@/services/mall/goodsCategory";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable
    // StoreToString,
  },
  // directives: {
  //   waves,
  // },
  created() {
    this.getListData();
    this.getParentList();
  },
  data() {
    return {
      parentList_one: [],
      parentList_two: [],
      downloadLoading: false,
      arrayByIdToNameStr,
      action: IP + "/uploadFile/add",
      fileList: [],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0,
        name: "",
        categoryLevel: "",
        parentID: ""
      },
      stateList: [
        { id: 1, name: "一级分类" },
        { id: 2, name: "二级分类" },
        { id: 3, name: "三级分类" }
      ],
      statusList: [
        { id: 0, name: "正常" },
        { id: 1, name: "下架" }
      ],
      recommendList: [
        { id: 0, name: "否" },
        { id: 1, name: "是" }
      ],
      parentList: [],
      /* 表格数据 */
      tableData: [],
      allTableData: [],
      storeList: [],
      /* 弹窗 */
      dialogName: "",
      dialogVisible: false,
      dialogForm: {},
      categoryLevelList: [
        { id: 0, name: "显示" },
        { id: 1, name: "隐藏" }
      ],
      disableList: [
        { id: 0, name: "不跳转" },
        { id: 1, name: "跳转" }
      ],
      roleVisible: false,
      navData: [],
      checkedData: [],
      defaultProps: {
        children: "children",
        label: "label"
      }
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo"])
  },

  watch: {},
  methods: {
    changeLevel(e) {
      console.log(e);
    },

    async getListData(listQuery) {
      this.loading = true;

      const { data, code, count } = await queryList(
        listQuery || this.listQuery
      );
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
      }

      const result = await queryList({
        pageNumber: 1,
        pageSize: 5000
      });
      if (result.code === 200) {
        this.allTableData = result.data.map(item => {
          return {
            ...item,
            name: item.categoryName
          };
        });
      }

      this.loading = false;
    },

    async getParentList() {
      //重新刷新列表
      this.parentList_one = await this.getParentList_api({
        pageNumber: 1,
        pageSize: 5000,
        categoryLevel: 1
      });
      this.parentList_two = await this.getParentList_api({
        pageNumber: 1,
        pageSize: 5000,
        categoryLevel: 2
      });
    },

    async getParentList_api(prop) {
      const { data, code, count } = await queryList(prop);
      if (code === 200) {
        return data.map(item => {
          return {
            ...item,
            name: item.categoryName
          };
        });
      }
    },
    /* 搜索按钮 */
    async search() {
      this.listQuery.pageNumber = 1;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 显示商品sku设置 */
    recommendChange(row, val) {
      this.$confirm(
        `是否确认${val == "1" ? "设置" : "取消"}首页推荐？`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(async () => {
        if (val === true) {
          row.recommend = 1;
        } else {
          row.recommend = 0;
        }
        updateList({ id: row.id, recommend: row.recommend }).then(res => {
          if (res.code === 200) {
            this.$message({
              type: "success",
              message: "操作成功",
              offset: 100
            });
            this.getListData();
          } else {
            this.$message({
              type: "error",
              message: "操作失败",
              offset: 100
            });
            if (val == "0") {
              row.recommend = 1;
            } else {
              row.recommend = 0;
            }
          }
        });
      });
    },

    /* 新增 */
    handleAdd() {
      this.dialogVisible = true;
      this.dialogName = "创建";
      this.dialogForm = {};
    },

    /* 修改 */
    handleEdit(row) {
      this.dialogVisible = true;
      this.dialogName = "信息编辑";
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },

    handleSuccess(e) {
      console.log("handleSuccess", e);
      this.dialogForm.img_head = e.data;
      this.fileList = [];
      this.$message.success("上传成功，请继续操作");
    },

    save() {
      if (
        !this.dialogForm.categoryName ||
        !this.dialogForm.categoryLevel ||
        (!this.dialogForm.parentID && this.dialogForm.categoryLevel === 2)
      ) {
        this.$message.error("请填写必填选项");
        return;
      }
      if (!this.dialogForm?.id) {
        addList({
          ...this.dialogForm
        }).then(res => {
          if (res.code === 200) {
            this.listQuery.pageNumber = 1;
            this.getListData();
            this.getParentList();
            this.$message({
              type: "success",
              message: "创建成功!"
            });
            this.dialogVisible = false;
          }
        });
      } else {
        updateList({
          ...this.dialogForm
        }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.getParentList();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
            this.dialogVisible = false;
          }
        });
      }
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          deleteList({ id: row.id }).then(res => {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.getListData();
          });
        })
        .catch(() => {});
    },

    /* 导出数据 */
    handleDownload() {
      this.downloadLoading = true;
      import("@/utils/vendor/Export2Excel").then(excel => {
        const tHeader = [
          "ID",
          "分类状态",
          "分类名称",
          "分类主图",
          "分类等级",
          "所属父分类",
          "排序(越大排名越靠前)"
        ];
        const filterVal = [
          "id",
          "status",
          "categoryName",
          "img_head",
          "categoryLevel",
          "parentID",
          "sort"
        ];
        const list = this.tableData.map(item => {
          return {
            ...item,
            status: item.status === 0 ? "正常" : "下架",
            categoryLevel: item.categoryLevel === 1 ? "一级" : "二级"
          };
        });
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "商品分类数据下载",
          autoWidth: true, //Optional
          bookType: "xlsx" //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v =>
        filterVal.map(j => {
          return v[j];
        })
      );
    }
  }
};
</script>

<style scoped lang="less">
.selectForm {
  background: #fff;
  padding: 10px 0;
  margin: 10px auto;
}

.tableList {
  border-radius: 6px;
  background: #fff;
  margin: 10px auto;
}

// 设置权限
::v-deep
  .el-tree-node__content
  .el-checkbox
  .el-checkbox__input.is-checked
  .el-checkbox__inner,
::v-deep
  .el-tree-node__content
  .el-checkbox
  .el-checkbox__input.is-indeterminate
  .el-checkbox__inner {
  background-color: #afb68d;
  border-color: #afb68d;
}

::v-deep
  .el-tree-node__content
  .el-checkbox
  .el-checkbox__input
  .el-checkbox__inner:hover {
  border-color: #afb68d;
}

.elImage {
  width: 50px;
}
</style>
